import type { ClashTriageMap } from './clashTriage'

// ---------------------------------------------------------------------------
// O ponto onde a corrida (clashCorrida.ts) chama a triagem partilhada,
// sem a importar: a partilha regista-se aqui quando esta activa.
//
// Antes de reconciliar, a triagem local recebe o que a partilhada sabe
// dos conflitos desta corrida (casados pelos GlobalIds): a reconciliacao
// trabalha sobre o que toda a gente decidiu, e o que ela muda (resolvido,
// reaberto) segue para os outros como qualquer outra alteracao.
// ---------------------------------------------------------------------------

export interface ParDaCorrida {
  key: string
  guids: readonly [string | null, string | null]
  kind: string
}

export interface GanchoDaPartilha {
  /** A reconciliacao comecou: o que chegar do servidor espera. */
  inicio: () => void
  /** Junta a triagem partilhada dos conflitos desta corrida. */
  fundir: (triagem: ClashTriageMap, pares: readonly ParDaCorrida[]) => ClashTriageMap
  /** A reconciliacao acabou (gravada, retida ou falhada). */
  fim: () => void
}

let gancho: GanchoDaPartilha | null = null

export function registarGanchoDaPartilha(g: GanchoDaPartilha | null): void {
  gancho = g
}

export function ganchoDaPartilha(): GanchoDaPartilha | null {
  return gancho
}
